import { lorem, parseHex, formatValue, gri, shi, overall, blues, distance, angle } from "../Utils";
import { OFFSCREEN_X, OFFSCREEN_Y } from "../Constants";
import * as d3 from "d3";


export default class MapLayout {
	constructor(type="map", slice=Infinity, nodes, offset_x=0, offset_y=0) {
		this.type = type;
		this.slice = slice;
		this.nodes = nodes;
		this.offset_x = offset_x;
		this.offset_y = offset_y;
		this.labels = document.createDocumentFragment();
		const s = document.createElement('span');
		s.setAttribute('class', `label`);
		s.setAttribute('style', `top:${12}px`);
		s.setAttribute('data-top', `${12.0}`);
		// add an empty label to the overlay to keep the label resizing mechanism working properly. There's a better way to do this
		this.labels.appendChild(s);
		this.x_force = d3.forceX( d => { return this._coordinates_x(d.id) || OFFSCREEN_X }).strength(0);
		this.y_force = d3.forceY( d => { return this._coordinates_y(d.id) || OFFSCREEN_Y }).strength(0);
	}
	_coordinates_x(id, offset=true) {
		return typeof this.nodes[id] == 'undefined' ? undefined : this.nodes[id].mx + ( offset ? this.offset_x : 0);
	}
	_coordinates_y(id, offset=true) {
		return typeof this.nodes[id] == 'undefined' ? undefined : this.nodes[id].my + ( offset ? this.offset_y : 0);
	}
}
